import { jsx, jsxs } from "react/jsx-runtime";
import { useState, useEffect, useRef } from "react";
import { B as Box } from "./Grid-CcQKdsgp.js";
import { U as UIKitOverlay } from "./UIKitOverlay-C2yXBjdm.js";
import { usePopover, DismissButton } from "@react-aria/overlays";
const IS_SERVER = typeof window === "undefined";
function useMediaQuery(query, {
  defaultValue = false,
  initializeWithValue = true
} = {}) {
  const getMatches = (searchQuery) => {
    if (IS_SERVER) {
      return defaultValue;
    }
    return window.matchMedia(searchQuery).matches;
  };
  const [matches, setMatches] = useState(() => {
    if (initializeWithValue) {
      return getMatches(query);
    }
    return defaultValue;
  });
  useEffect(() => {
    if (IS_SERVER) {
      return;
    }
    const matchMedia = window.matchMedia(query);
    setMatches(matchMedia.matches);
    const handleChange = () => {
      setMatches(matchMedia.matches);
    };
    if (matchMedia.addListener) {
      matchMedia.addListener(handleChange);
    } else {
      matchMedia.addEventListener("change", handleChange);
    }
    return () => {
      if (matchMedia.removeListener) {
        matchMedia.removeListener(handleChange);
      } else {
        matchMedia.removeEventListener("change", handleChange);
      }
    };
  }, [query]);
  return matches;
}
const Popover = ({
  children,
  state,
  variant = "positioned",
  placement = "bottom",
  d,
  md,
  portalContainer,
  ...props
}) => {
  var _a, _b, _c;
  const popoverRef = useRef(null);
  const isMd = useMediaQuery("(min-width: 768px)", {
    defaultValue: false
  });
  const isLg = useMediaQuery("(min-width: 1024px)", {
    defaultValue: false
  });
  const currentPlacement = isLg ? (_a = d == null ? void 0 : d.placement) != null ? _a : md == null ? void 0 : md.placement : isMd ? md == null ? void 0 : md.placement : placement;
  const { popoverProps, underlayProps } = usePopover(
    { ...props, popoverRef, placement: currentPlacement != null ? currentPlacement : placement },
    state
  );
  if (variant === "static") {
    return /* @__PURE__ */ jsx("div", { ...underlayProps, children: /* @__PURE__ */ jsxs(
      Box,
      {
        ...props,
        ref: popoverRef,
        bg: (_b = props.bg) != null ? _b : "background-transparent",
        border: { radius: "8px" },
        className: `transition-all duration-300 ease-in-out ${state.isOpen ? " visible" : "invisible"}`,
        opacity: state.isOpen ? 100 : 0,
        children: [
          /* @__PURE__ */ jsx(DismissButton, { onDismiss: () => state.close() }),
          children,
          /* @__PURE__ */ jsx(DismissButton, { onDismiss: () => state.close() })
        ]
      }
    ) });
  } else {
    return /* @__PURE__ */ jsxs(UIKitOverlay, { portalContainer, children: [
      /* @__PURE__ */ jsx("div", { ...underlayProps }),
      /* @__PURE__ */ jsxs(
        Box,
        {
          ...popoverProps,
          ...props,
          ref: popoverRef,
          style: {
            ...popoverProps.style
          },
          bg: (_c = props.bg) != null ? _c : "background-transparent",
          border: { radius: "8px" },
          children: [
            /* @__PURE__ */ jsx(DismissButton, { onDismiss: () => state.close() }),
            children,
            /* @__PURE__ */ jsx(DismissButton, { onDismiss: () => state.close() })
          ]
        }
      )
    ] });
  }
};
export {
  Popover as P
};
